<template>
  <div class="default-box">
    <slot></slot>
    <loader v-if="loader"/>
  </div>
</template>

<script>
import Loader from "../small_components/Loader";
export default {
  name: "DefaultBox",
  components: {Loader},
  props: {
    loader: {
      type: Boolean,
      default: false
    }
  }
}
</script>
